module.exports = __webpack_public_path__ + "assets/d0cfae9d35575df027c2180057ca1556.mp4";